import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';

import { Responsavel } from '../agendamento/responsavel';
import { ResponsavelService } from '../agendamento/responsavel.service';

@Component({
  selector: 'app-confirmacao-agendamento',
  templateUrl: './confirmacao-agendamento.component.html',
  styleUrls: ['./confirmacao-agendamento.component.css'],
  providers: [
    ResponsavelService
  ]
})
export class ConfirmacaoAgendamentoComponent implements OnInit {

  public responsavel: Responsavel;

  msg: string;

  agendamentoFeito: boolean = false;

  constructor(private responsavelService: ResponsavelService, private route: ActivatedRoute,
  private router: Router, private _flashMessagesService: FlashMessagesService,) {
    this.responsavel = new Responsavel();
  }

  getDados(): void {
    this.route.params.forEach((params: Params) => {
     let id = params['id']; // id do agendamento
     let token = params['token']; // token de verificacao
     let flag = params['flag']; // flag de desistencia da entrevista

     //console.log(id);
     //console.log(token);
     if (id !== undefined && token !== undefined) {
       if (flag === undefined) {
         this.responsavelService.getDadosAgendamento(id,token)
           .then((responsavel) => {
             if (responsavel['dados'] != null) { // retorna dados possiveis do agendamento
               console.log(responsavel['dados']);
               if (responsavel['dados'][0]['dataHoraEscolhida'] !== null) {
                   this.agendamentoFeito = true;
               }
               this.responsavel.id_agendamento = responsavel['dados'][0]['id'];
               this.responsavel.id_incidente = responsavel['dados'][0]['id_incidente'];
               this.responsavel.local = responsavel['dados'][0]['local'];
               this.responsavel.dhop1 = responsavel['dados'][0]['dataHoraOpcao1'];
               this.responsavel.dhop2 = responsavel['dados'][0]['dataHoraOpcao2'];
               this.responsavel.token = responsavel['dados'][0]['token'];
               this.responsavel.dataHoraEscolhida = responsavel['dados'][0]['dataHoraEscolhida'];
             }
             else {
               this.msg = "Acesso não autorizado!";
             }

           }
         );
       }
       else { // relator desistiu da entrevista
         this.responsavelService.desistenciaEntrevista(id,token)
             .then((responsavel) => {console.log(responsavel); this.msg = responsavel['dados'];});
       }

     }

   });

 }

 salvar(): void {
   console.log(this.responsavel);
   if (this.responsavel.id_agendamento) {
     this.responsavelService.salvarAgendamentoRelator(this.responsavel)
         .then(() => this.goBack());
   }
 }

 goBack(): void {
    //this.router.navigate(['denuncias']);
 }

  ngOnInit() {
    this.getDados();
  }

}



// WEBPACK FOOTER //
// ./src/app/confirmacao-agendamento/confirmacao-agendamento.component.ts